const TokenKey = 'admin_token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getUserId() {
  return localStorage.getItem('admin_user_id')
}

export function setUserId(id) {
  return localStorage.setItem('admin_user_id', id)
}

export function removeUserId() {
  return localStorage.removeItem('admin_user_id')
}

export function getAdminCache() {
  const info = localStorage.getItem('admin_user_info')
  return info ? JSON.parse(info) : null
}

export function setAdminInfo(info) {
  return localStorage.setItem('admin_user_info', JSON.stringify(info))
}

export function removeAdminInfo() {
  return localStorage.removeItem('admin_user_info')
}

export function clearAuth() {
  removeToken()
  removeUserId()
  removeAdminInfo()
}